import ContentBox from '~/components/ContentBox';
import { useFeatureFlag } from '~/hooks/account';
import { audienceSubtypeEnabled } from '~/lib/audiences';
import {
  adsDestinationTypes,
  alertDestinationTypes,
  createAccountDestinationTypes,
  personalizationDestinationTypes,
} from '~/lib/destinations';
import { segmentTypes } from '~/lib/segments';

import AddPlanSection from './AddPlan/AddPlanSection';
import {
  AddAudience,
  AddDestination,
} from './Destination/AddDestinationOrAudience';
import styles from './styles';
import { audienceSubTypesToShowAsDestinations } from './utils';

function LegacyPlanDestinations({ userContainer, classes, segment, account }) {
  const showAlerting = userContainer.shouldShowDestinationGroup('alerting');
  const showAdsProducts = userContainer.shouldShowDestinationGroup('ads');
  const showCreateAccounts =
    useFeatureFlag('x_destination_create_salesforce_account').enabled &&
    segment.type === 'CompanySegment';
  const showPersonalization = userContainer.shouldShowDestinationGroup(
    'personalization',
  );
  const adDestinations = adsDestinationTypes(segment);

  return (
    <>
      {showCreateAccounts ? (
        <>
          <ContentBox.Title>
            <h2 className={classes.heading}>Create new accounts</h2>
            <p className={classes.infoText}>
              Automatically receive new companies within your CRM.{' '}
              <a href="#" style={{ textDecoration: 'underline' }}>
                Learn More
              </a>
            </p>
          </ContentBox.Title>
          {createAccountDestinationTypes().map((type) => (
            <AddDestination
              key={type}
              className={classes.audienceItem}
              type={type}
              segment={segment}
            />
          ))}
          <ContentBox.Break className={classes.break} />
        </>
      ) : null}

      {showAlerting ? (
        <>
          <ContentBox.Title>
            <h2 className={classes.heading}>Alerting and notifications</h2>
            <p className={classes.infoText}>
              Send alerts and notifications to your teams.
            </p>
          </ContentBox.Title>
          {alertDestinationTypes().map((type) => (
            <AddDestination
              key={type}
              className={classes.audienceItem}
              type={type}
              segment={segment}
            />
          ))}
        </>
      ) : (
        <AddPlanSection
          title="Alerting"
          user={userContainer}
          segment={segment}
        />
      )}

      <ContentBox.Break className={classes.break} />

      {showAdsProducts ? (
        <>
          {adDestinations.length > 0 ? (
            <>
              <ContentBox.Title>
                <h2 className={classes.heading}>Conversion events</h2>
                <p className={classes.infoText}>
                  Send conversion events to advertising networks.
                </p>
              </ContentBox.Title>
              {adDestinations.map((type) => (
                <AddDestination
                  key={type}
                  className={classes.audienceItem}
                  type={type}
                  segment={segment}
                />
              ))}

              <ContentBox.Break className={classes.break} />
            </>
          ) : null}

          <ContentBox.Title>
            <h2 className={classes.heading}>Advertising audiences</h2>
            <p className={classes.infoText}>
              Send audience matches to Facebook for effective, targeted
              advertising.
            </p>
          </ContentBox.Title>
          {audienceSubTypesToShowAsDestinations[segment.type]?.map(
            (audienceSubtype) =>
              audienceSubtypeEnabled(account?.plans, audienceSubtype) && (
                <AddAudience
                  key={audienceSubtype}
                  className={classes.audienceItem}
                  subtype={audienceSubtype}
                  segment={segment}
                />
              ),
          )}
        </>
      ) : (
        <AddPlanSection
          title="Advertising"
          user={userContainer}
          segment={segment}
        />
      )}

      {segment.type == segmentTypes.company && (
        <>
          <ContentBox.Break className={classes.break} />
          {showPersonalization ? (
            <>
              <ContentBox.Title>
                <h2 className={classes.heading}>Personalization</h2>
                <p className={classes.infoText}>
                  Customize your website in realtime.
                </p>
              </ContentBox.Title>

              {personalizationDestinationTypes(segment).map((type) => (
                <AddDestination
                  key={type}
                  className={classes.audienceItem}
                  type={type}
                  segment={segment}
                />
              ))}
            </>
          ) : (
            <AddPlanSection
              title="Personalization"
              user={userContainer}
              segment={segment}
            />
          )}
        </>
      )}
    </>
  );
}

export default withStyles(styles)(LegacyPlanDestinations);
